import { useMemo } from 'react';
import styles from './NoizeValue.module.css';

export const NoizeValue = ({ noiseLevel }) => {
  const clr = useMemo(() => {
    if (noiseLevel <= 33) {
      return '#36ff07';
    } else if (noiseLevel <= 66) {
      return '#ffff00';
    } else return '#ff0048';
  }, [noiseLevel]);

  const noiseLevelString = noiseLevel
    ? noiseLevel?.replaceAll('.', ',')?.split('')
    : '';

  return (
    <div className={styles.noizeValue}>
      <svg viewBox="0 0 200 200" className={styles.firstSvg}>
        <path
          d="M 100 20 A 80 80 0 0 1 100 180"
          fill="none"
          stroke="#04EEFF"
          strokeWidth="2"
        />
      </svg>

      <svg viewBox="0 0 200 200" className={styles.secondSvg}>
        <path
          d="M 100 13 A 87 87 0 0 1 100 187"
          fill="none"
          stroke={clr}
          strokeWidth="4"
        />
      </svg>

      <div className={styles.noiseLevel}>
        {noiseLevelString && (
          <div className={styles.stringValue}>
            {noiseLevelString?.map((l, i) => (
              <div key={l + i}>{l}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
